import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { ApiGetDataStatus, BoxStateType } from '@redux/types'
import { BoxType, ProductPackagingType } from '@schemas'

const initialState: BoxStateType = {
	boxList: [],
	boxListStatus: 'init',
	updateBox: {
		boxId: '',
		code: '',
		name: '',
		widthCm: 0,
		heightCm: 0,
		depthCm: 0,
		tareKg: 0,
		useYn: 1,
		memo: '',
		iudFlag: 'I',
	},

	packagingList: [],
	packagingListStatus: 'init',
	updatePackaging: { productId: '', boxId: '', netKg: null },

	triggerInitBox: false,
	error: '',
}

const slice = createSlice({
	name: 'box',
	initialState,
	reducers: {
		// trigger
		TRIGGER_INIT_BOX_PAGE: (state: BoxStateType, action: PayloadAction<boolean>) => {
			state.triggerInitBox = action.payload
		},

		// boxes
		BOX_LIST: (state: BoxStateType, action: PayloadAction<BoxType[]>) => {
			state.boxList = action.payload
		},
		BOX_LIST_STATUS: (state: BoxStateType, action: PayloadAction<ApiGetDataStatus>) => {
			state.boxListStatus = action.payload
		},
		UPDATE_BOX: (
			state: BoxStateType,
			action: PayloadAction<BoxStateType['updateBox']>,
		) => {
			state.updateBox = action.payload
		},

		// product packaging
		PACKAGING_LIST: (
			state: BoxStateType,
			action: PayloadAction<ProductPackagingType[]>,
		) => {
			state.packagingList = action.payload
		},
		PACKAGING_LIST_STATUS: (
			state: BoxStateType,
			action: PayloadAction<ApiGetDataStatus>,
		) => {
			state.packagingListStatus = action.payload
		},
		UPDATE_PACKAGING: (
			state: BoxStateType,
			action: PayloadAction<BoxStateType['updatePackaging']>,
		) => {
			state.updatePackaging = action.payload
		},

		ERROR: (state: BoxStateType, action: PayloadAction<string>) => {
			state.error = action.payload
		},
	},
})

export const boxActions = slice.actions
export default slice.reducer
